var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gacha-title-section",style:({
     'color': _vm.titleSection.titleColor,
     'font-weight': _vm.titleSection.titleWeight
   })},[_vm._v("\n     "+_vm._s(_vm.getterTitle)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }